import { render } from "./recordLog.vue?vue&type=template&id=57052aa3"
import script from "./recordLog.vue?vue&type=script&lang=js"
export * from "./recordLog.vue?vue&type=script&lang=js"

import exportComponent from "D:\\git\\tsunagaru-app\\public\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__